import React, { useRef } from 'react';
import IconButton from '@mui/material/IconButton';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';

function AudioButton(props) {
  // Get the URL of the audio file from props
  const audioUrl = props.audioUrl;

  // Create a ref for the audio element
  const audioRef = useRef();
  

  // Define a function to toggle the audio playback
  const togglePlay = () => {
    const isPlaying = !audioRef.current.paused;
    // Check if the audio is playing
    // Play or pause the audio accordingly
    if (isPlaying) {
    //   audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
  };

  return (
    <div>
      {/* Render the audio element with the ref and the URL */}
      <audio ref={audioRef} src={audioUrl} />

      {/* Render the custom button with the toggle function */}
      <IconButton onClick={togglePlay}>
        {/* { isPlaying ? */}
        {/* <VolumeUpIcon/> :  */}
        <VolumeUpIcon sx={{color:'black'}}/>
        {/* } */}
      </IconButton>
    </div>
  );
}

export default AudioButton;